import { create as createStore } from 'zustand';

export * from 'zustand';
/**
 * This is zustand's `create` function renamed to `createStore` to help with auto-imports
 * Otherwise it's easy to have conflicts with other `create`s like `lodash/create`
 */
export default createStore;

// Export new stores
export * from './event';
export * from './user';

// For backward compatibility, re-export the main hooks
export { useEvent, useEventContext } from './event';
export { useUserContext as useUser } from './user';
